@if (avoinna()) {
  <div class="search-overlay" (mousedown)="taustaaKlikattu($event)">
    <div class="search-panel" role="dialog" aria-modal="true" cdkTrapFocus [attr.aria-label]="'tuotteet.haku.modal-otsikko' | translate | async">
      <app-icon-button additionalClass="search-close" matIcon="close" [ariaLabel]="'tuotteet.haku.sulje' | translate | async" (click)="sulje()" actionId="Tuotehaku: sulje"></app-icon-button>

      <div class="search-content">
        <div class="search-field">
          <mat-form-field>
            <mat-icon matPrefix class="listaus-haku-ikoni">search</mat-icon>
            <mat-label>{{ 'tuotteet.haku.hakukentan-placeholder' | translate | async }}</mat-label>
            <input type="text" matInput #hakukentta [formField]="hakuteksti" />
          </mat-form-field>
        </div>

        <div class="results">
          @if (haetaan()) {
            <div class="hint">{{ 'tuotteet.haku.haetaan' | translate | async }}</div>
          } @else if (tulokset().length === 0) {
            @if (hakusana()) {
              <div class="hint">
                {{ 'tuotteet.haku.ei-osumia-haulla' | translate: { hakusana: hakusana() } | async }}
                <div>{{ 'tuotteet.haku.ei-osumia-vihje' | translate | async }}</div>
              </div>
            } @else {
              <div class="hint">{{ 'tuotteet.haku.hakuohje' | translate | async }}</div>
            }
          } @else {
            <ul class="tulokset-lista">
              @for (tuote of tulokset(); track tuote.$key) {
                <li class="tulos-rivi" role="button" tabindex="0" (click)="avaaTuote(tuote)" (keydown.enter)="avaaTuote(tuote)" (keydown.space)="$event.preventDefault(); avaaTuote(tuote)">
                  <div class="tulos-otsikko">{{ tuote.nimi }}</div>
                  <div class="tulos-lisatiedot">
                    <span>
                      {{ tuote.hinta | lmoney: (tuote.valuutta || 'EUR') | async }}
                      @if (tuote.yksikko) {
                        / {{ tuote.yksikko }}
                      }
                    </span>
                    @if (tuote.kuvaus) {
                      <span>{{ tuote.kuvaus }}</span>
                    }
                  </div>
                </li>
              }
            </ul>
            <mat-paginator class="haku-paginator" [length]="kokonaismaara()" [pageIndex]="sivu()" [pageSize]="sivunKoko()" [pageSizeOptions]="sivukoot" showFirstLastButtons (page)="sivuMuuttui($event)"></mat-paginator>
          }
        </div>
      </div>
    </div>
  </div>
}
